import * as React from 'react';
import { CardNumberElement, CardCVCElement, CardExpiryElement, injectStripe } from 'react-stripe-elements';

import { Label, TextInput } from '../components/forms';

const stripeFieldStyles = {
	base: {
		color: '#333',
		fontFamily: '"Nunito Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
		fontSize: '16px',
		lineHeight: '1.5',
		'::placeholder': {
			color: 'rgba(51, 51, 51, 0.25)'
		}
	},
	invalid: {
		color: '#dc3545'
	}
};

interface Props {
	details: any;
	actions: any;
	stripe?: any;
	onStripeElementChange?: (element: any, name: any) => void;
}
class InjectedPaymentDetailsForm extends React.Component<Props> {
	componentDidMount() {
		this.props.actions.setStripe(this.props.stripe);
	}

	onPaymentDetailsChange = (e: any) => {
		const details = {
			...this.props.details,
			[e.target.name]: e.target.value
		};

		this.props.actions.setPaymentDetails(details);
	}

	render() {
		return (
			<fieldset>
				<div className="row">
					<div className="form-group col-sm-8">
						<Label>Credit card number</Label>
						<CardNumberElement
							className="form-control"
							style={stripeFieldStyles}
							onChange={this.props.onStripeElementChange ?
								(element: any) => this.props.onStripeElementChange!(element, 'card_number') :
								undefined
							}
						/>
					</div>
					<div className="form-group col-sm-4 mb-sm-2">
						<Label>Expiry date</Label>
						<CardExpiryElement
							className="form-control"
							style={stripeFieldStyles}
							onChange={this.props.onStripeElementChange ?
								(element: any) => this.props.onStripeElementChange!(element, 'card_expiry') :
								undefined
							}
						/>
					</div>
					<div className="form-group col-sm-4">
						<Label>CVC</Label>
						<CardCVCElement
							className="form-control"
							style={stripeFieldStyles}
							onChange={this.props.onStripeElementChange ?
								(element: any) => this.props.onStripeElementChange!(element, 'card_cvv') :
								undefined
							}
						/>
					</div>
					<TextInput
						labelText="Cardholder's name"
						name="ccCardholderName"
						onChange={this.onPaymentDetailsChange}
						value={this.props.details.ccCardholderName}
						className="col-sm-8 mb-0"
					/>
				</div>
			</fieldset>
		);
	}
}
export default injectStripe(InjectedPaymentDetailsForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/payment/InjectedPaymentDetailsForm.tsx